import { Component, OnInit, Inject, TemplateRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from "@angular/forms";
import { AuthenticationService } from "@shared/services/authentication.service";
import swal from "sweetalert2";
import { ActivatedRoute, Router, Params} from "@angular/router";
import { OneSignalService } from "@app/onesignal.service";
import { AppStateService } from "@app/shared/services/app-state.service";
import { DOCUMENT } from "@angular/common";
import { MixpanelEventLoggingService } from "@app/shared/services/mixpanel-event-logging.service";
import { WebSocketService } from "../main/roles-shared/services/web-socket.service";
import { Constants } from "@shared/constants/app.constants";
import { Title } from "@angular/platform-browser";
import { NewUser } from "../external/account/shared/models/account.models";
import { SsoLoginService } from "@app/shared/services/sso-login.service";
import { SsoMsg } from "@app/util/sso-login-key";
import { UserVerificationService } from "@app/shared/services/user-verification.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap";

declare const SecureLS;
declare var window: any;

@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.css"]
})
export class SignInComponent implements OnInit {
  loginForm: FormGroup;

  rememberMeStatus = "";
  submitCount = 0;
  canSubmit = true;
  hidePassword = false;
  accessToken: any;
  userId = "";
  password = "";
  email = "";
  buttonValidate: boolean;
  phoneNumber: any;
  ssoDomainMsg: any;
  secureLocalStorage = new SecureLS({ encodingType: "aes" });
  domain: any;
  domainname: any;
  currentForm = 'login';
  userAccessToken = '';
  modalRef: BsModalRef;

  newUser = new NewUser();

  registrationForm: FormGroup;
  workEmailInvalid: boolean;
  workEmailInvalidMessage: any;
  modeOfRegistration = "Email";
  via = 'Web';
  userRole = "tech_vendor";
  unknownUser: boolean;
  emailVerifiedNew: any;

  public currentlyClickedCardIndex: number = 1;
  response: Object;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public formBulder: FormBuilder,
    private oneSignalService: OneSignalService,
    private appStateService: AppStateService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private webSocketService: WebSocketService,
    private ssoService: SsoLoginService,
    private userVerificationService: UserVerificationService,
    private modalService: BsModalService,
    private route: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.document.body.classList.add("outer-page");
    this.document.body.classList.remove("inner-page");
    this.ssoDomainMsg = SsoMsg;
    // window.scroll(0, 0);
    this.registrationForm = formBulder.group(
      {
        emailId: formBulder.control(
          "",
          [Validators.required, Validators.pattern(Constants.emailRegex)],
          this.emailCheck.bind(this)
        ),
        password: formBulder.control(
          "",
          [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(12),
            Validators.pattern(Constants.passwordRegex)
          ],
          this.passwordCheck.bind(this)
        ),
        terms: formBulder.control("", Validators.required),
        role: formBulder.control("", Validators.required)
      }
    );
  }


  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params["userAccessToken"] && params["userId"]) {
        this.userAccessToken = params["userAccessToken"];
        this.userId = params["userId"];
        this.accessToken = params.accessToken;
        this.verifyUser();
      }
      if(params.hasOwnProperty('email')){
        this.currentForm = 'signup';
      }
    });
    this.createForm();
    if (window.localStorage.getItem("rememberMeStatus") === "true") {
      this.email = this.secureLocalStorage.get(
        "5dr34cxv@9_x!fo2s8%^4uo93#in*"
      ).email;
      this.password = this.secureLocalStorage.get(
        "5dr34cxv@9_x!fo2s8%^4uo93#in*"
      ).password;
      this.rememberMeStatus = "true";
      const x: any = document.getElementById("rem");
      x.checked = true;
    }

    if (
      window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null" &&
      window.localStorage.getItem("rememberMeStatus") === "true" &&
      window.localStorage.getItem("logoutStatus") === "false"
    ) {
      if (
        JSON.parse(window.localStorage.getItem("userDetails")).roles[0].code ===
        "tech_buyer"
      ) {
        this.appStateService.setState(true);
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(JSON.parse(window.localStorage.getItem("userDetails")))
        );
        this.mixpanelEventLoggingService.dispatchEvent("login", {
          "Email ID": "email",
          "User Role": "tech_buyer",
          "Mode of Login": "Email",
          "Device": "Web"
        });
        this.router.navigate(["tech-buyer"]);
      } else if (
        JSON.parse(window.localStorage.getItem("userDetails")).roles[0].code ===
        "tech_vendor"
      ) {
        this.appStateService.setState(true);
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(JSON.parse(window.localStorage.getItem("userDetails")))
        );
        this.mixpanelEventLoggingService.dispatchEvent("login", {
          "Email ID": "email",
          "User Role": "tech_vendor",
          "Mode of Login": "Email",
          "Device": "Web"
        });
        this.router.navigate(["tech-vendor"]);
      } else if (
        JSON.parse(window.localStorage.getItem("userDetails")).roles[0].code ===
        "ecosystm_staff"
      ) {
        this.appStateService.setState(true);
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(JSON.parse(window.localStorage.getItem("userDetails")))
        );
        this.mixpanelEventLoggingService.dispatchEvent("login", {
          "Email ID": "email",
          "User Role": "ecosystm_staff",
          "Mode of Login": "Email",
          "Device": "Web"
        });
        this.router.navigate(["ecosystm-staff"]);
      }
      if (
        JSON.parse(window.localStorage.getItem("userDetails")).roles[0].code ===
        "tech_analyst"
      ) {
        this.appStateService.setState(true);
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(JSON.parse(window.localStorage.getItem("userDetails")))
        );
        this.mixpanelEventLoggingService.dispatchEvent("login", {
          "Email ID": "email",
          "User Role": "tech_analyst",
          "Mode of Login": "Email",
          "Device": "Web"
        });
        this.router.navigate(["tech-analyst"]);
      }
    }
  }

  public setcurrentlyClickedCardIndex(cardIndex: number): void {
    this.currentlyClickedCardIndex = cardIndex;
  }

  public checkIfCardIsClicked(cardIndex: number): boolean {
    return cardIndex === this.currentlyClickedCardIndex;
  }

  passwordCheck(control: AbstractControl) {
    return new Promise(resolve => resolve(''));
  }
  emailCheck(control: AbstractControl) {
    return new Promise(resolve => resolve(''));
  }
  termsOpen() {
    window.open("/#/terms-of-use", "Terms & Conditions");
  }
  privacyOpen() {
    window.open("/#/privacy-policy ", "Privacy Policy");
  }

  // check black listed domain list
  async checkBlacklistedDomain() {
    if (!this.registrationForm.value.emailId) {
      return;
    }
    if (this.registrationForm.value.emailId) {
      this.domain = this.registrationForm.value.emailId.substring(this.registrationForm.value.emailId.lastIndexOf("@") + 1);
      this.domainname = this.domain.indexOf(this.ssoDomainMsg.orgDomain);
    }
    if (this.domain && this.domainname >= 0) {
      swal("Info", this.ssoDomainMsg.SignUpMsg, "info");
      return;
    }
    let userType = await this.authenticationService.checkBlockListDomain(this.registrationForm.value.emailId, 'tech_vendor').subscribe(
      (response: any) => {
        this.workEmailInvalid = false;
        this.unknownUser = false;
        this.registrationForm.controls['role'].setValue('tech_vendor');
        return response;
      },
      error => {
        if(error['error']['error']['message'].includes("Tech Buyer")) {
          this.userRole = 'tech_buyer';
          this.registrationForm.controls['role'].setValue('tech_buyer');
          this.workEmailInvalid = false;
          this.unknownUser = false;
        } else if(error['error']['error']['message'].includes("Congratulations!")) {
          this.userRole = 'tech_buyer';
          this.registrationForm.controls['role'].setValue('tech_buyer');
          this.unknownUser = true;
          this.workEmailInvalid = false;
        } else {
          this.workEmailInvalid = true;
          this.workEmailInvalidMessage = error['error']['error']['message'];
        }
      }
    );
  }

  verifyUser() {
    
    this.userVerificationService
      .verifyUser(this.userId, this.userAccessToken)
      .subscribe(
        response => {
          this.response = response;
          if (this.accessToken) {
            this.authenticationService.tokenLogin(this.accessToken).subscribe(
              (response: any) => {
                this.buttonValidate = false;
                this.canSubmit = true;
                this.accessToken = response.id;
                this.userId = response.userId;
                this.emailVerifiedNew = response.userDetails.emailVerifiedNew;
                if (this.emailVerifiedNew) {
                  window.sessionStorage.setItem('activatedNow', true);
                }
                this.getUserDetails(response);
              },
              error => {
                if (error.status === 403) {
                  swal({
                    title: "Account Not Verified!",
                    text: "Well, we can resend the link",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Resend",
                    cancelButtonText: "No thanks",
                    confirmButtonClass: "btn adjust-swal-button",
                    cancelButtonClass: "btn adjust-swal-button",
                    buttonsStyling: false
                  }).then(result => {
                    if (result.value) {
                      this.resendVerificationEmail();
                    }
                  });
                } else {
                  swal("Info", error.error.error.message, "info");
                }
                //  this.submitCount++;
                this.canSubmit = true;
              }
            );
          } else {
            swal("Success", "Account Verified!", "success");
          }
        },
        error => {
          if (error.error.error.statusCode === 422) {
            swal("Info", error.error.error.message, "info");
            this.router.navigate(["/signin"]);
          } else {
            swal({
              title: "This link has expired!",
              text: "Well, we can resend the link",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Resend",
              cancelButtonText: "No thanks",
              confirmButtonClass: "btn adjust-swal-button",
              cancelButtonClass: "btn adjust-swal-button",
              buttonsStyling: false
            }).then(result => {
              if (result.value) {
                this.resendVerificationEmail();
              }
            });
          }
        }
      );
  }

  async openModalBeforeSignup(template: TemplateRef<any>) {
    if(this.userRole == "tech_buyer") {
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-lg' })
      );
    } else {
      await this.onSubmit();
    }
  }

  async onSubmit() {
    if (!this.registrationForm.valid || this.workEmailInvalid) {
      this.buttonValidate = true;
      this.validateAllFormFields(this.registrationForm);
    } else {
      this.newUser.email = this.registrationForm.value.emailId;
      this.newUser.password = this.registrationForm.value.password;
      this.newUser.roleCode = this.userRole;

      await this.authenticationService.registerUser(this.newUser).subscribe(
        (data: any) => {
          const resetData = {
            email: data.email,
            otpMethod: "mobile",
            phoneNumber: data.phoneNumber
          };
          this.mixpanelEventLoggingService.dispatchEvent("signup", {
            ModeofRegistration: this.modeOfRegistration,
            Device: "Web",
            Via: this.via,
            EmailID: data.email,
            UserRole: this.userRole
          });
          window.sessionStorage.setItem("user_role", this.userRole);
          window.sessionStorage.setItem("resetData", JSON.stringify(resetData));
          // login after signup
          const loginCredentials = {
            email: this.registrationForm.value.emailId,
            password: this.registrationForm.value.password
          };
          this.authenticationService.login(loginCredentials).subscribe(
            (response: any) => {
              this.buttonValidate = false;
              this.canSubmit = true;
              this.accessToken = response.id;
              this.userId = response.userId;
              this.getUserDetails(response);
            },
            error => {
              if (error.status === 403) {
                swal({
                  title: "Email not verified!",
                  text: "Well, we can resend the link",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#3085d6",
                  confirmButtonText: "Resend",
                  cancelButtonText: "No thanks",
                  confirmButtonClass: "btn adjust-swal-button",
                  cancelButtonClass: "btn adjust-swal-button",
                  buttonsStyling: false
                }).then(result => {
                  if (result.value) {
                    this.resendVerificationEmail();
                  }
                });
              } else {
                swal("Info", error.error.error.message, "info");
              }
            //  this.submitCount++;
              this.canSubmit = true;
            }
          );
        },
        error => {
          swal("Info", error.error.error.message, "info");
        }
      );
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  
  getSsoIn () {
    if (window.sessionStorage.getItem("ssoUserType")) {
      window.sessionStorage.removeItem('ssoUserType');
   }
    window.sessionStorage.setItem("user_role", "tech_vendor");
    localStorage.setItem('ssoUserType', 'tech_vendor');
    this.ssoService.setuserRoleSourceValue("tech_vendor");
    this.router.navigate(['account/registration-sso'],{replaceUrl:true});
  }

  createForm() {
    this.loginForm = this.formBuilder.group({
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$"
          )
        ]
      ],
      password: ["", Validators.required]
    });
  }

  login() {
    if (this.submitCount > 5) {
      swal(
        "Sorry",
        "You have exceeded the maximum allowed attempts.Please revisit the website after sometime. Thanks",
        "warning"
      );
      setTimeout(() => {
        this.submitCount = 0;
      }, 600000);
    } else {
      if (
        this.loginForm.value.email === "" &&
        this.loginForm.value.password === ""
      ) {
        this.buttonValidate = true;
        this.loginForm.controls["email"].markAsTouched();
        this.loginForm.controls["password"].markAsTouched();
      } else if (this.loginForm.value.email === "") {
        this.buttonValidate = true;
        this.loginForm.controls["email"].markAsTouched();
      } else if (this.loginForm.value.password === "") {
        this.buttonValidate = true;
        this.loginForm.controls["password"].markAsTouched();
      } else if (this.loginForm.valid && this.canSubmit) {

        this.canSubmit = false;
        const loginCredentials = {
          email: this.loginForm.value.email,
          password: this.loginForm.value.password
        };
        this.email = this.loginForm.value.email;
        if (this.loginForm.value.email) {
          this.domain = this.loginForm.value.email.substring(this.loginForm.value.email.lastIndexOf("@") + 1);
          this.domainname = this.domain.indexOf(this.ssoDomainMsg.orgDomain);
        }
        if (this.domain && this.domainname >= 0) {
          swal("Info", this.ssoDomainMsg.signInOrgMsg, "info");
          this.submitCount++;
          this.canSubmit = true;
        } else {
          this.authenticationService.login(loginCredentials).subscribe(
            (response: any) => {
              this.buttonValidate = false;
              this.submitCount++;
              this.canSubmit = true;
              this.accessToken = response.id;
              this.userId = response.userId;
              this.getUserDetails(response);
              //   console.log(response.userDetails.contactNumbers[0].contactNumber, 'number');

              let _hsq = window._hsq = window._hsq || [];
              _hsq.push(["identify", {
                email: (response != null && response.userDetails != null) ? response.userDetails.email : '',
                firstName: (response != null && response.userDetails != null) ? response.userDetails.firstName : '',
                lastName: (response != null && response.userDetails != null) ? response.userDetails.lastName : '',
                role: (response != null && response.userDetails != null && response.userDetails.roles.length > 0) ? response.userDetails.roles[0].code : '',
                //    number: (response != null && response.userDetails != null && response.userDetails.contactNumbers.length > 0) ? response.userDetails.contactNumbers[0].contactNumber : '',
              }]);

              _hsq.push(['trackPageView']);
              _hsq.push(['refreshPageHandlers']);

            },
            error => {
              if (error.status === 403) {
                swal({
                  title: "Email not verified!",
                  text: "Well, we can resend the link",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#3085d6",
                  confirmButtonText: "Resend",
                  cancelButtonText: "No thanks",
                  confirmButtonClass: "btn adjust-swal-button",
                  cancelButtonClass: "btn adjust-swal-button",
                  buttonsStyling: false
                }).then(result => {
                  if (result.value) {
                    this.resendVerificationEmail();
                  }
                });
              } else {
                swal("Info", error.error.error.message, "info");
              }
              this.submitCount++;
              this.canSubmit = true;
            }
          );
        }
      }
    }
  }

  updateLocalUserProfile() {
    const OneSignal = window['OneSignal'] || [];
    OneSignal.getUserId().then((userId) => {
      // Store OneSignal ID in your server for sending push notificatios.
      const params = {
        // deviceToken = oneSignalId
        deviceToken: userId,
        deviceType: 'browser'
      };
      this.authenticationService.registerWebPushDevice(params).subscribe(
        (response: any) => {
        },
        error => {
        }
      );
    });
  }

  toogleLogin(action) {
    if (action === "show") {
      const p = document.getElementById("login-password");
      p.setAttribute("type", "text");
      this.hidePassword = !this.hidePassword;
    } else {
      const p = document.getElementById("login-password");
      p.setAttribute("type", "password");
      this.hidePassword = !this.hidePassword;
    }
  }
  toogleSignup(action) {
    if (action === "show") {
      const p = document.getElementById("signup-password");
      p.setAttribute("type", "text");
      this.hidePassword = !this.hidePassword;
    } else {
      const p = document.getElementById("signup-password");
      p.setAttribute("type", "password");
      this.hidePassword = !this.hidePassword;
    }
  }

  rememberMe(data: HTMLInputElement) {
    if (data.checked) {
      this.rememberMeStatus = "true";
    } else {
      this.rememberMeStatus = "false";
    }
  }

  resendVerificationEmail() {
    this.authenticationService.resendVerificationEmail(this.email).subscribe(
      response => {
        swal("Success", "Please check your email", "success");
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    );
  }

  getUserDetails(userInfo) {
    this.authenticationService
      .getuserDetails(this.userId, this.accessToken)
      .subscribe(
        (response: any) => {
          this.webSocketService.initializeSocket(response.id, response.roles[0].id, this.accessToken)
          response.userId = this.userId;
          response.accessToken = this.accessToken;
          // this.webSocketService.connectSocket();
          // this.webSocketService.initializeSocket(response.id,response.roles[0].id,this.accessToken)
          const userData =
          {
            salutationId: response.salutationId,
            firstName: response.firstName,
            middleName: response.middleName,
            lastName: response.lastName,
            nickName: response.nickName,
            email: response.email,
            jobTitleId: response.jobTitleId,
            lineOfBusinessId: response.lineOfBusinessId,
            geographicResponsibilityId: response.geographicResponsibilityId,
            organizationId: response.organizationId,
            biography: response.biography,
            isActive: response.isActive,
            profileUrl: response.profileUrl,
            token: this.accessToken
          };
          this.authenticationService.setAuth(userData);
          this.authenticationService.setEBSAuth(response);

          this.mixpanelEventLoggingService.loginDispatchEvent(userInfo.userDetails);
          if (this.rememberMeStatus === "true") {
            window.localStorage.setItem("rememberMeStatus", "true");
            this.secureLocalStorage.set("5dr34cxv@9_x!fo2s8%^4uo93#in*", {
              email: this.email,
              password: this.password
            });
            window.localStorage.setItem(
              "userDetails",
              JSON.stringify(response)
            );
          } else {
            window.localStorage.setItem("rememberMeStatus", "false");
            window.localStorage.removeItem("credentials");
            window.localStorage.removeItem("userDetails");
          }
          window.localStorage.setItem("logoutStatus", "false");
          window.sessionStorage.setItem(
            "userDetails",
            JSON.stringify(response)
          );
          //  ------- One Signal Registration - Starts -------
          // Send tags here
          this.oneSignalService.sendPushTags(
            response.userId,
            response.roles[0].code
          );
          // Call subscribe Ecosystm API here
          this.updateLocalUserProfile();
          //  ------- One Signal Registration - Ends -------

          this.mixpanelEventLoggingService.dispatchEvent("login", {
            "Email ID": "email",
            "User Role": response.roles[0].code,
            "Mode of Login": "Email",
            "Device": "Web"
          });
          const redirectURL = localStorage.getItem("REDIRECT_URL");
          const redirectReportURL = localStorage.getItem('REPORT_URL');
          const redirectResearchURL = localStorage.getItem('RESEARCH_URL');
          const redirectResearchBuyerURL = localStorage.getItem('RESEARCH_BUYER_URL');
          const redirectResearchAnalystURL = localStorage.getItem('RESEARCH_ANALYST_URL');
          const redirectResearchStaffURL = localStorage.getItem('RESEARCH_STAFF_URL');
          const isFromHome = localStorage.getItem('isFromHome');
          const isProfileCompleted = localStorage.getItem('profileCompleted');
          localStorage.removeItem("REDIRECT_URL");
          localStorage.removeItem("REPORT_URL");
         // localStorage.removeItem("RESEARCH_URL");
          localStorage.removeItem("RRESEARCH_BUYER_URL");
          localStorage.removeItem("RESEARCH_ANALYST_URL");
          localStorage.removeItem("RESEARCH_STAFF_URL");
          if (redirectURL) {
            this.appStateService.setState(true);
            this.router.navigateByUrl(redirectURL);
          } else if (redirectReportURL) {
            this.appStateService.setState(true);
            if (response.roles[0].code === "tech_buyer") {
              this.router.navigateByUrl("tech-buyer" + redirectReportURL);
            } else if (response.roles[0].code === "tech_vendor") {
              this.router.navigateByUrl("tech-vendor" + redirectReportURL); 
            } else if (response.roles[0].code === "tech_analyst") {
              this.router.navigateByUrl("tech-analyst/reports" + redirectReportURL);
            } else if (response.roles[0].code === "ecosystm_staff") {
              this.router.navigateByUrl("ecosystm-staff" + redirectReportURL);
            }
          }  else if (redirectResearchURL) {
            this.appStateService.setState(true);

             if (response.roles[0].code === "tech_vendor") {
              if (isFromHome === "true" && (isProfileCompleted != '100') ) {
                this.route.navigate(["/tech-vendor/complete-my-profile"]);
               }else{
              this.router.navigateByUrl("tech-vendor" + redirectResearchURL);
               }
            } 
          } 
          else if (redirectResearchBuyerURL) {
            this.appStateService.setState(true);

             if (response.roles[0].code === "tech_buyer") {
               if (isFromHome === "true" && (isProfileCompleted != '100') ) {
                this.route.navigate(["/tech-buyer/complete-my-profile"]);
               }else{
                 this.router.navigateByUrl("tech-buyer/research-snapshot" + redirectResearchBuyerURL);
                }
            } 
          } 
         else  if (redirectResearchAnalystURL) {
            this.appStateService.setState(true);

             if (response.roles[0].code === "tech_analyst") {
              this.router.navigateByUrl("tech-analyst/research-snapshot" + redirectResearchAnalystURL);
            } 
          } 
         else if (redirectResearchStaffURL) {
            this.appStateService.setState(true);

             if (response.roles[0].code === "ecosystm_staff") {
              this.router.navigateByUrl("ecosystm-staff/research-snapshot" + redirectResearchStaffURL);  
            } 
          }
          else {
            if (response.roles[0].code === "tech_buyer") {
              this.router.navigate(["tech-buyer"]);
            } else if (response.roles[0].code === "tech_vendor") {
              this.router.navigate(["tech-vendor"]);
            } else if (response.roles[0].code === "tech_analyst") {
              this.router.navigate(["tech-analyst"]);
            } else if (response.roles[0].code === "ecosystm_staff") {
              this.router.navigate(["ecosystm-staff"]);
            }
          }

          //
        },
        error => {

        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/sign-in/sign-in.component.ts